import { Application } from "@hotwired/stimulus"
import TaskController from "./task_controller"
import GpsClockController from "./gps_clock_controller"
const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

application.register("task", TaskController)
application.register("gps-clock", GpsClockController)

export { application }
